import { privateAxios } from 'services/api/privateAxios';
import { adminAPI } from 'services/api/apiUrl';

export const setCustomerRating = (id, rating) =>
  privateAxios({
    method: 'post',
    baseURL: adminAPI,
    url: `/customer/setrating/${id}`,
    data: {
      rating,
    },
  });
